import React from 'react';
import type { ViewStyle } from 'react-native';

/**
 * Append last on form control roots so `formGroup` never stacks margin with
 * {@link FormFieldStack} `gap` or card `formSectionContentPaddingWeb`.
 */
export const formFieldInStack: ViewStyle = { marginBottom: 0 };

const FormFieldStackSpacingContext = React.createContext(false);

/** @internal Used by {@link FormFieldStack} only. */
export function FormFieldStackSpacingProvider({
  children,
}: {
  children: React.ReactNode;
}): React.ReactElement {
  return (
    <FormFieldStackSpacingContext.Provider value={true}>
      {children}
    </FormFieldStackSpacingContext.Provider>
  );
}

/**
 * True when the field renders inside {@link FormFieldStack} (or `StepForm` with default
 * `withFieldStack`). Suppresses per-control `formGroup` bottom margin so vertical rhythm
 * comes only from the stack `gap` + card `formSectionContentPaddingWeb` (20px).
 */
export function useFormFieldInStack(): boolean {
  return React.useContext(FormFieldStackSpacingContext);
}
